/** What a purchasable catalogue item represents. */
export enum CatalogueItemKind {
  /** A plan tier subscription. Exactly one entitling plan item per account. */
  Plan = 'plan',
  /** A recurring, quantity-based extra that raises a numeric cap. */
  Addon = 'addon',
  /** A one-time credit top-up. */
  Credit = 'credit',
}

export enum AddonType {
  EmployeeSeat = 'employee_seat',
}

export enum CreditType {
  Sms = 'sms',
}

export enum BillingInterval {
  Month = 'month',
  Year = 'year',
}

export enum SmsCreditReason {
  Purchase = 'purchase',
  Consumption = 'consumption',
  Adjustment = 'manual_adjustment',
  Refund = 'refund',
}
